import type { Dayjs } from "dayjs";
import type { Competition } from "../../lib/queries/competitions";

/**
 * Where „dnes" sits along the season rail, as a percentage of its width.
 *
 * Placed by ORDER rather than by date, because the stops are: they occupy
 * equal columns, so a date-proportional marker could land on the wrong side
 * of a dot and quietly lie about what has already happened. It sits in the
 * gap between the last competition that has run and the next that has not —
 * hard left before the season starts, hard right once it is over.
 *
 * Dots sit at the CENTRE of their columns — (i + 0.5) / n — so the gap
 * between dot i-1 and dot i falls exactly at i / n. Keep this in step with
 * `.stop` in the stylesheet: if the dots ever move back to column starts,
 * this marker silently points at the wrong gap.
 *
 * Returns null when a competition is running: that dot is then the live
 * thing, and the page is allowed exactly one red (DESIGN.md §1).
 */
export function todayPercent(sorted: Competition[], now: Dayjs): number | null {
  if (sorted.length === 0) return null;
  if (sorted.some((c) => c.status === "running")) return null;
  const today = now.format("YYYY-MM-DD");
  // A multi-day event is not behind us until its last day is.
  const past = sorted.filter((c) => (c.date_to ?? c.date) < today).length;
  return (past / sorted.length) * 100;
}
